// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"700d06db","453":"fd3b9533","553":"76950d20","977":"2e30f6fd"}[chunkId] + ".chunk.js";
};